import { isEmpty } from 'lodash'
import { createListViewContainer } from 'factories/ListView'
import inventoryActions from 'actions/inventory'
import orderItemActions from 'actions/orders/orderItems'
import { getSharedInventory, getSharedLocations } from 'helpers/offlineData'
import { updatePrivateItem } from 'helpers/localForage'
import { wrapData, wrapItems, sortItems, filterBySearch } from 'helpers/utils'
import { ISSUED_ITEMS_SAVED_KEY } from 'options/inventory/issue'
import Component from 'components/Issue/IssueItem/SearchInventory'

export default createListViewContainer({
  extraDispatchToProps: (dispatch, props) => ({
    getItems: (params = {}) =>
      dispatch(inventoryActions.getListViewItems(params)).catch(async (error) => {
        if (!error.response) {
          const { locationIds = [] } = params
          const [items, locations] = await Promise.all([getSharedInventory(), getSharedLocations()])

          const filterLocationIds = isEmpty(locationIds) ? locations.map((each) => each.id) : locationIds

          const unsortedItems = items
            .filter((each) => isEmpty(filterLocationIds) || filterLocationIds.includes(each.locationId))
            .filter(filterBySearch(params.search))

          return Promise.resolve(sortItems(unsortedItems, params.sortByField, params.sortOrder)).then(
            wrapItems
          )
        }

        throw error
      }),
    issueOrderItem: (params) =>
      dispatch(orderItemActions.issueOrderItem(0, params)).catch(async (error) => {
        if (!error.response) {
          await updatePrivateItem(ISSUED_ITEMS_SAVED_KEY, [], (draft) => {
            draft.unshift({ id: Date.now() * -1, ...params })
          })

          return wrapData({
            clientNotifications: [
              {
                type: 'Warning',
                description: 'issueQuantityHasBeenSavedOnDevice',
              },
            ],
            successCount: 1,
            failureCount: 0,
          })
        }

        throw error
      }),
  }),
})(Component)
